import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ae58798"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-iwp-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Working papers", -1))
const _hoisted_5 = { class: "body-main" }
const _hoisted_6 = { class: "ls-form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Max file size: 50MB", -1))
const _hoisted_8 = { class: "ma-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Information ", -1))
const _hoisted_10 = { class: "checkbox-button" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Required for final report")
], -1))
const _hoisted_12 = { class: "checkbox-button" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Tag this file as evidence?")
], -1))
const _hoisted_14 = { class: "controls mt-4" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_18 = {
  key: 0,
  class: "delete-file"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "DELETE FILE", -1))

export function render(_ctx, _cache) {
  const _component_FileDragAndDrop = _resolveComponent("FileDragAndDrop")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[6] || (_cache[6] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.editMode ? 'Edit ' : 'Add new file'), 1),
          _hoisted_4
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("fieldset", null, [
              (!_ctx.editMode)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_FileDragAndDrop, {
                      disabled: false,
                      ref: "fileDropAndDrop",
                      onFileInputChanged: _ctx.fileListChanged,
                      numFileLimit: 1,
                      fileSizeLimit: 50
                    }, null, 8, ["onFileInputChanged"]),
                    _hoisted_7
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.formData.information) = $event)),
                  style: {"border":"1px solid #aaa","resize":"vertical","width":"100%","height":"250px"}
                }, null, 512), [
                  [_vModelText, _ctx.formData.information]
                ])
              ]),
              _createElementVNode("label", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.formData.requiredFinalReport) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formData.requiredFinalReport]
                ]),
                _hoisted_11
              ]),
              _createElementVNode("label", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.formData.taggedAsEvidence) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formData.taggedAsEvidence]
                ]),
                _hoisted_13
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "btn btn-default",
              disabled: _ctx.submitting,
              onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
            }, " Back ", 8, _hoisted_15),
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: _ctx.submitting || !(_ctx.isFormDirty && _ctx.validForm),
              onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.addNewIWP()), ["prevent","stop"]))
            }, [
              _createTextVNode(_toDisplayString(_ctx.editMode ? 'Save changes' : 'Add file'), 1),
              _hoisted_17
            ], 8, _hoisted_16),
            (_ctx.submitting)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                  key: 0,
                  class: "loading-indicator",
                  showLoadingText: false
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createTextVNode(" Or "),
                _createElementVNode("a", {
                  class: "link2",
                  onClick: _cache[5] || (_cache[5] = $event => (_ctx.showDeleteAlert = true))
                }, "delete file")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_ctx.showDeleteAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 0,
          onClose: _cache[9] || (_cache[9] = $event => (_ctx.showDeleteAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_19
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", null, "Are you sure you want to delete " + _toDisplayString(this.formData.file.name) + "?", 1)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              onClick: _cache[7] || (_cache[7] = $event => (_ctx.showDeleteAlert = false))
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.yesDeleteClicked && _ctx.yesDeleteClicked(...args)))
            }, "Delete")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}